import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { getMe, UserProfile } from "../services/api";

interface UserProfileState {
    profile: UserProfile | null;
    roles: string[];
    isSubcontractor: boolean;
    loading: boolean;
    error: string | null;
}

export const useUserProfile = (): UserProfileState => {
    const { accounts } = useMsal();
    const [state, setState] = useState<UserProfileState>({
        profile: null,
        roles: [],
        isSubcontractor: false,
        loading: true,
        error: null,
    });

    useEffect(() => {
        const fetchProfile = async () => {
            if (!accounts[0]) return;
            try {
                // Goes through the shared `api` client, whose request
                // interceptor acquires a fresh token itself (see api.ts) --
                // no need to fetch/cache a token here separately.
                const data = await getMe();
                setState({
                    profile: data,
                    roles: data.roles || [],
                    isSubcontractor: !!data.is_subcontractor,
                    loading: false,
                    error: null,
                });
            } catch (err) {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    error: "Failed to load user profile",
                }));
            }
        };
        fetchProfile();
    }, [accounts]);

    return state;
};
